module.exports = __webpack_public_path__ + "img/color-2_jp.3e03145.jpg";